export default __webpack_public_path__ + "static/media/thingsboard_blue.9451d8be.png";